import React from "react"
import './newUcc.scss'
import UccSearch from "./Components/UccSearch/UccSearch"
import UccFilings from "./Components/UccFIlings/UccFilings";
import UccDirectAmendments from "./Components/UccDirectAmendments/UccDirectAmendments";
import { Grid } from "@material-ui/core";
import AuthService from "tools/AuthService";
import AccessRequestAlert from "components/shared/AccessRequestAlert";

const NewUCCTabContent = ({ applicationId, handleSubmitUccPosting, debtorApplication, creditCosts, creditUsageEnabled }) => {
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}')
    const currentUser = AuthService.loggedInUser || storedUser
    const showUccAccessRequest = currentUser?.showUccAccessRequest === true
    const clientName = currentUser?.securityContext?.client?.clientName || ''
    const clientId = currentUser?.securityContext?.client?.clientId || ''
    const userEmail = currentUser?.email || ''

    if (showUccAccessRequest) {
        return (
            <Grid container>
                <Grid item xs={12} className='m-3'>
                    <AccessRequestAlert
                        type="ucc"
                        clientName={clientName}
                        clientId={clientId}
                        userEmail={userEmail}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid container>
            <Grid item xs={12} className='m-3'>
                <UccSearch applicationId={applicationId}
                           debtorApplication={debtorApplication}
                           creditUsageEnabled={creditUsageEnabled}
                           creditCosts={creditCosts}
                />
            </Grid>
            {!debtorApplication && 
                <>
                    <Grid item xs={12} className='m-3'>
                        <UccFilings applicationId={applicationId} handleSubmitUccPosting={handleSubmitUccPosting} creditCosts={creditCosts} />
                    </Grid>
                    <Grid item xs={12} className='m-3'>
                        <UccDirectAmendments applicationId={applicationId} />
                    </Grid>
                </>}
        </Grid >
    )
}

export default NewUCCTabContent
